import { RemixiconComponentType } from '@remixicon/react';

export const IconStations: RemixiconComponentType = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <path d="M7 3a1 1 0 0 0-2 0v18a1 1 0 1 0 2 0V3zM3 9a1 1 0 0 0-2 0v6a1 1 0 1 0 2 0V9zm7-3a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1zm5 4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-4zm3-5a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1zm5 4a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0V9z" />
  </svg>
);
